import { AttachmentStatusEnum as GQLAttachmentStatusEnum } from '../../generated/graphql';
import { take } from '../../util';
import { z } from 'zod';
export const AttachmentStatus = Object.freeze({
    PENDING: 'pending',
    UPLOADING: 'uploading',
    READY: 'ready',
    FAILED: 'failed',
});
export const attachmentSchema = z.object({
    id: z.number().optional(),
    name: z.string(),
    mime: z.string(),
    size: z.number(),
    checksum: z.string().optional(),
    status: z.nativeEnum(AttachmentStatus).optional(),
    url: z.string().url().optional(),
});
export const gqlStatusMap = {
    [GQLAttachmentStatusEnum.Pending]: AttachmentStatus.PENDING,
    [GQLAttachmentStatusEnum.Uploading]: AttachmentStatus.UPLOADING,
    [GQLAttachmentStatusEnum.Ready]: AttachmentStatus.READY,
};
export const fromGql = (gqlItem) => (Object.assign(Object.assign({}, take(gqlItem, 'id', 'name', 'mime', 'size', 'checksum', 'url')), { status: gqlItem.status ? gqlStatusMap[gqlItem.status] : undefined }));
//# sourceMappingURL=Attachment.js.map